
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';
import store from '@/store';

@Options({})
export default class Home extends Vue {

    created(){

    }

    get hasMenu(){
        return false;
    }

    newTavola(){
        store.state.tavola = new OM.Tavola();
        this.$router.push('/table/step0')
    }

}
